import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { reactQueryDelete } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { commentCache } from "@/react/lib/queries/comments";
import type { Comment } from "@/react/types/Comment";

interface UseDeleteCommentParams {
  comment: Comment;
  onSuccess: () => void;
}

export const useDeleteComment = ({
  comment,
  onSuccess,
}: UseDeleteCommentParams) => {
  const { id, post_id: postId, parent_comment_id: parentCommentId } = comment;
  const { success, error } = useToast();

  const { mutate: deleteComment, isPending } = useMutation({
    mutationFn: () =>
      reactQueryDelete(internalApi.comments.destroy({ postId, id })),
    onSuccess: () => {
      commentCache.remove({ postId, id, parentCommentId });
      onSuccess();
      success(t("comments.delete.alerts.success"));
    },
    onError: () => {
      error(t("comments.delete.alerts.failure"));
    },
  });

  return { deleteComment, isPending };
};
